// These methods belong to every table view with sort
import _ from "lodash";

export default {
  data() {
    return {
      sort: {},
    };
  },
  computed: {
    orderBy() {
      let order = [];
      _.forEach(this.sort, (value, key) => {
        if (value != "normal") {
          order.push(key + "." + value);
        }
      });
      return order.length > 0 ? order.toString() : undefined;
    },
  },
  methods: {
    sortTable(column) {
      this.sort = {};
      this.sort[column["key"]] = column["order"];
      this.load();
    },
  },
};
